import { ImageToPdfForm } from '@/features/image-to-pdf'

export function JpgVPdfForm() {
  return <ImageToPdfForm mode="jpg" />
}
